module fdm.flightLegs {

    angular.module('fdm.flightLegs', [])
        .run((parameterValuesService: ParameterValuesService, queryExecutionStrategyFactory: dg.actions.QueryExecutionStrategyFactory) => {
            queryExecutionStrategyFactory.registerStrategy('parameter-values', parameterValuesService);
    });
}